/* eslint-disable max-len */
/**
 * Module dependencies
 */
const React = require('react');
const Image = require('nordic/image');
const Form = require('@andes/form');
const Breadcrumb = require('@andes/breadcrumb');

const { BreadcrumbLevel } = Breadcrumb;
const TextField = require('@andes/textfield');
const List = require('@andes/list');
const { injectI18n } = require('nordic/i18n');

const { ListItem } = List;

const Button = require('@andes/button');
const ChevronRight32 = require('@andes/icons/ChevronRight32');
const moment = require('moment');
const { MelidataTrack } = require('nordic/melidata/melidata-track');
const ListMenu = require('../ListMenu');
const Hotjar = require('../HotJar');
const { sanitizeHTML } = require('../../helpers/sanitizeHtml');
const simplifiedPages = require('./constants');

/**
 * TwoColumnView Component
 */
class TwoColumnView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pass: props.queryParams?.password || '',
      isDivFixed: false,
      titleArray: [],
      isOpen: (props.deviceType !== 'mobile'),
    };

    this.handleSubmitForm = this.handleSubmitForm.bind(this);
    this.handleFormInputChange = this.handleFormInputChange.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, true);
    const hTitles = document.querySelectorAll('h1, h2');
    const titleArray = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < hTitles.length; i++) {
      titleArray.push({
        id: hTitles[i].id,
        title: hTitles[i].innerText,
      });
    }
    this.setState({
      titleArray,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleFormInputChange(event) {
    this.setState({
      pass: event.target.value,
    });
  }

  handleSubmitForm(e) {
    e.preventDefault();

    const { origin, pathname, search } = window.location;
    const searchParams = new URLSearchParams(search);

    searchParams.set('password', this.state.pass);

    window.location.href = `${origin}${pathname}?${searchParams.toString()}`;
  }

  handleScroll() {
    if (window.scrollY > 298) {
      this.setState({
        isDivFixed: true,
      });
    } else {
      this.setState({
        isDivFixed: false,
      });
    }
  }

  toggleOpenState() {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  }

  render() {
    const { page, sideCategories, location, deviceType, siteId, queryParams, isCBT, i18n } = this.props;
    const { titleArray } = this.state;
    const { password = null } = queryParams || {};
    const pathBreadcumb = isCBT ? '' : sideCategories.reference;
    const pathBreadcumbLang = isCBT ? 'devsite' : location;
    const shouldRenderSimplifiedPage = simplifiedPages.find((path) => path === page.path);

    const buParam = {
      mshops: page.mshops,
      mlibre: page.mlibre,
      menvios: page.menvios,
    };

    if (page.protected && !page.is_validated) {
      return (
        <div>
          <Hotjar siteId={siteId} traffic={{ from: 0, to: 100 }} />
          <Form className="page-form" onSubmit={this.handleSubmitForm}>
            <p> {i18n.gettext('Este contenido está protegido por contraseña. Para verlo introduce tu contraseña a continuación:')} </p>
            <TextField
              data-testid="page-form__password"
              srLabel="Password"
              className="page-form__password"
              width="75"
              onChange={this.handleFormInputChange}
              helper={password ? i18n.gettext('Contraseña incorrecta') : ''}
              modifier={password ? 'error' : ''}
              value={this.state.pass}
            />
            <Button type="submit"> {i18n.gettext('Entrar')} </Button>
          </Form>
        </div>
      );
    }

    const isApiDocs = sideCategories.name === 'API Docs';
    const categoryNameValidation = sideCategories.children_categories.filter(cat => cat.id === page.category_id);

    const quantityOfTrue = [+page.menvios + +page.mlibre + +page.mshops];
    let crossTextTitle = '';
    let crossTextSubtitle = '';

    const applicationManagement = sideCategories.children_categories.find(cat => cat.id === page.category_id);
    const applicationManagementID = applicationManagement?.id;

    if (applicationManagementID === 59 || applicationManagementID === 29 || applicationManagementID === 19) {
      crossTextTitle = i18n.gettext('Gestión de aplicaciones');
      crossTextSubtitle = i18n.gettext('Consulta la información esencial para trabajar con nuestras APIs');
    } else {
      crossTextTitle = i18n.gettext('Recursos Cross');
      crossTextSubtitle = i18n.gettext('Explora los recursos principales de nuestras APIs');
    }

    const securityCategory = this.props.sideCategories.children_categories[0]?.children_categories[1];
    const securityPages = securityCategory?.pages;
    const securityID = securityPages?.map(securityId => securityId.id);

    const bugBountyPages = this.props.sideCategories?.pages;
    const bugBountyID = bugBountyPages?.map(bugBountyId => bugBountyId.id);

    if (securityID) {
      switch (page.id) {
        case 6354:
        case 6356:
        case 6350:
          crossTextTitle = i18n.gettext('Seguridad');
          crossTextSubtitle = i18n.gettext('Consulta las prácticas de seguridad para operar nuestras APIs');
          break;
        default:
          break;
      }
    }

    const busPage = {
      mshops: page.mshops,
      mlibre: page.mlibre,
      menvios: page.menvios,
    };
    let BU = '';
    let isRender = '';

    if (quantityOfTrue <= 1) {
      isRender = false;
      if (busPage.mshops) {
        BU = 'MS';
      } else if (busPage.menvios) {
        BU = 'ME';
      } else {
        BU = 'ML';
      }
    } else {
      isRender = true;
    }

    let buText = '';

    if (quantityOfTrue <= 1) {
      switch (BU) {
        case 'MS':
          buText = 'Mercado Shops';
          break;
        case 'ML':
          buText = i18n.gettext('Mercado Libre');
          break;
        case 'ME':
          buText = i18n.gettext('Mercado Envíos');
          break;
        default:
          buText = i18n.gettext('Mercado Libre');
          break;
      }
    }

    const breadcrumbText = sideCategories.name === 'API Docs' ? sideCategories.name : 'API Docs';

    let hasSingleBusinessUnitTitle = '';
    let hasSingleBusinessUnitSubtitle = '';

    if (bugBountyID) {
      switch (page.id) {
        case 6354:
        case 6356:
        case 6350:
          hasSingleBusinessUnitTitle = 'Security Researchers';
          hasSingleBusinessUnitSubtitle = i18n.gettext('Si crees que has encontrado una vulnerabilidad de seguridad en alguno de nuestros sitios web, te invitamos y agradecemos mucho que lo informes a Mercado Libre.');
          break;
        default:
          hasSingleBusinessUnitTitle = `${i18n.gettext('Documentación ')} ${buText}`;
          hasSingleBusinessUnitSubtitle = `${i18n.gettext('Descubre toda la información que debes conocer sobre las APIs de ')} ${buText}.`;
          break;
      }
    }

    return (
      <div>
        <Hotjar siteId={siteId} traffic={{ from: 0, to: 100 }} />
        <MelidataTrack path="/developers_site/api-docs/docs_selected" event_data={{ redirect_to: page.path }} />
        <section className="section__two-column">
          {page.banner && (
            <div className="banner">
              <Image src={page.banner} />
            </div>
          )}
          <div className="mesh-row__two-column">
            <div className="header-section__two-column">
              <div className="header-texts__two-column">
                {!shouldRenderSimplifiedPage && (<div className="breadcrumbs__two-column">
                  {isApiDocs && categoryNameValidation.length > 0 ? (
                    <div className="two-column-breadcrumbs-container requisitos">
                      <Breadcrumb
                        srLabel="Default example list"
                      >
                        <BreadcrumbLevel text={breadcrumbText} href={`/${pathBreadcumbLang}/${pathBreadcumb}`} />
                        <BreadcrumbLevel text={page.title} disabled />
                      </Breadcrumb>
                    </div>
                  ) : (
                    <div className="two-column-breadcrumbs-container requisitos">
                      <Breadcrumb
                        srLabel="Default example list"
                      >
                        <BreadcrumbLevel text={breadcrumbText} href={`/${pathBreadcumbLang}/${pathBreadcumb}`} />
                        <BreadcrumbLevel text={page.title} disabled />
                      </Breadcrumb>
                    </div>
                  )}
                </div>)}
                {quantityOfTrue > 1 ? (
                  <div>
                    <p>{crossTextTitle}</p>
                    <span>{crossTextSubtitle}</span>
                  </div>
                ) : (
                  <div className={shouldRenderSimplifiedPage ? 'two-column__bug-bounty' : ''}>
                    <p>{hasSingleBusinessUnitTitle}</p>
                    <span>{hasSingleBusinessUnitSubtitle}</span>
                  </div>
                )}
              </div>
              <div className="header-img__two-column">
                <Image
                  src="https://http2.mlstatic.com/storage/developers-site-cms-admin/DevImgs/230801158836-ImgMS--1-.png"
                  alt="circulos azuis em degrade"
                />
              </div>
            </div>
            <div className="mesh-col-l-12">
              {!shouldRenderSimplifiedPage && (<div className="mesh-col-l-3 mesh-row__categories">
                <p className="mesh-col-l-3__title">{i18n.gettext('Documentación ')}</p>
                <nav className="nav">
                  <ul className="nav__list">
                    <ListMenu
                      category={sideCategories}
                      deviceType={deviceType}
                      class_name="group-list"
                      id_name="group"
                      level="1"
                      page={page}
                      buParam={buParam}
                      quantityOfTrue={quantityOfTrue}
                      location={location}
                    />
                  </ul>
                </nav>
              </div>)}
              <div className="mesh-col-l-7 mesh-row__content">
                {isRender && (
                  <div className="doc-cross__content" id="doc-cross__content-id">
                    <div className="doc-cross__text">
                      <div className="doc-cross__icon" />
                      <p>{i18n.gettext('Puedes usar esta documentación para las siguientes unidades de negocio:')}</p>
                    </div>
                    <div className="doc-cross__buIcons">
                      {page.mlibre && (<div className="doc-cross__banner-ML" />)}
                      {page.mshops && (<div className="doc-cross__banner-MS" />)}
                      {page.menvios && (<div className="doc-cross__banner-ME" />)}
                    </div>
                  </div>
                )}
                <div className="lastUpdateSpan">
                  <span>{`${i18n.gettext('Última actualización')}  ${moment(page.last_update).format('DD/MM/YYYY')}`}</span>
                </div>
                <div
                  className="inner-content"
                  dangerouslySetInnerHTML={{ __html: sanitizeHTML(page.content) }}
                />
              </div>

              {!shouldRenderSimplifiedPage && (<div className={this.state.isOpen ? 'two-column__btn-content-wrap--open' : 'two-column__btn-content-wrap'}>
                {this.state.isOpen ? (
                  <div className={this.state.isDivFixed ? 'two-column__btn-content-fixed' : 'two-column__btn-content'}>
                    <div className="chevron-direction">
                      <button
                        aria-label="The titles of the documentation of the page"
                        className="two-column__btn-content-open"
                        onClick={() => this.toggleOpenState()}
                      >
                        <ChevronRight32 />
                      </button>
                      <button
                        aria-label="this is a button with the content page"
                        className="two-column__btn-button"
                        onClick={() => this.toggleOpenState()}
                      >
                        {i18n.gettext('Contenidos')}
                      </button>
                    </div>
                    <div className="btn-list-container">
                      {titleArray.length > 0 && (
                      <List
                        aria-label="Content"
                        id="list-content"
                        srLabel="List content"
                      >
                        {titleArray.map(index => (
                          <ListItem
                            href={`#${index.id}`}
                            title={index.title}
                            key={index.id}
                            value={`#${index.id}`}
                          />
                        ))}
                      </List>
                      )}
                    </div>
                  </div>
                ) : (
                  <button
                    aria-label="This is a button closed"
                    className={this.state.isDivFixed ? 'two-column__btn-content-closed-fixed' : 'two-column__btn-content-closed'}
                    onClick={() => this.toggleOpenState()}
                  >
                    <ChevronRight32 />
                  </button>
                )}
              </div>)}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

module.exports = injectI18n(TwoColumnView);
